export default __webpack_public_path__ + "media/images/76-1358594a407e794a3229adac61972bde.jpg";